/* globals showModalInfo */
import React, { useState, useContext, useEffect, useRef } from "react";
import Modal from "common/Modal.jsx";
import ActionsContext from "common/ActionsContext";
import BqnContext from "common/BqnContext";
import styled from "styled-components";
import Fields from "./Fields";
import { mergeStateOfDevices } from "../api";

const ErrorModal = styled.div`
  text-transform: uppercase;
  color: var(--Primary);
`;

const doesNothing = () => {};

const CreateWire = ({ others = [], doSave = doesNothing, interfaces = [] }) => {
  const actions = useContext(ActionsContext);
  const [wireCreation, setWireCreation] = useState(false);

  useEffect(() => actions.recv("new-wire", () => setWireCreation(true)), []);

  return wireCreation === true ? (
    <CreateWireModal
      others={others}
      doSave={doSave}
      doClose={() => setWireCreation(false)}
      interfaces={interfaces}
    />
  ) : null;
};

const getFormData = (form) => {
  const data = new FormData(form);
  const result = Object.fromEntries(data.entries());
  return {
    acc: { iface: result.accIface, pcap: result.accPcap === "on" },
    inet: { iface: result.inetIface, pcap: result.inetPcap === "on" },
  };
};

const getFilteredInterfaces = ({ interfaces, mode, bqnId }) => {
  if (mode === "standalone" || bqnId === "all") {
    return interfaces;
  }
  return interfaces.filter(({ bqn }) => parseFloat(bqn) === parseFloat(bqnId));
};

const CreateWireModal = ({
  doSave = doesNothing,
  doClose = doesNothing,
  interfaces = [],
}) => {
  const {
    clusterStatus: { mode },
    bqnId,
  } = useContext(BqnContext);
  const filteredInterfaces = getFilteredInterfaces({ interfaces, mode, bqnId });
  const form = useRef(null);
  const [error, setError] = useState(null);
  if (filteredInterfaces.length < 2) {
    return (
      <Modal
        title="Create Wire"
        superIcon="add_circle"
        large={false}
        content={() => (
          <ErrorModal>Not enough free interfaces available</ErrorModal>
        )}
        closeLabel="OK"
      />
    );
  }

  const clearError = () => setError(null);

  const doApply = () => {
    try {
      const currently = getFormData(form.current);
      const devicesByName = Object.fromEntries(
        interfaces.map((device) => [device.name, device])
      );
      if (mode === "standalone") {
        const newCurrently = {
          ...currently,
          bqn: bqnId,
        }
        doSave(mergeStateOfDevices(devicesByName)(newCurrently));
        doClose();
      } else {
        const { acc, inet } = currently;
        const [nameAcc, bqnAcc] = acc.iface.split("-");
        const [nameInt, bqnInt] = inet.iface.split("-");
        if (bqnAcc === bqnInt) {
          const newCurrently = {
            ...currently,
            acc: { ...acc, ["iface"]: nameAcc },
            inet: { ...inet, ["iface"]: nameInt },
            bqn: bqnInt,
          };
          doSave(mergeStateOfDevices(devicesByName)(newCurrently));
          doClose();
        } else {
          setError("Interfaces should be on the same BQN.");
        }
      }
    } catch (error) {
      setError(error);
    }
  };

  return (
    <Modal
      title="Create Wire"
      superIcon="add_circle"
      large={false}
      content={() => (
        <form ref={form}>
          <Fields interfaces={interfaces} onChange={clearError} />
        </form>
      )}
      applyLabel="OK"
      onApply={doApply}
      applyDisabled={error !== null}
      closeLabel="CANCEL"
      onClose={doClose}
      footerMessage={
        (error !== null && (
          <span className="modal-err-msg color-red align-left">{error}</span>
        )) ||
        null
      }
    />
  );
};
export default CreateWire;
